(ns portal.backup-image-table.view
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.resource.query.backup-image :as backup-image.q]
            [common.widgets.data-grid :as dg]
            [common.widgets.preview-pop-up :refer [preview-pop-up]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- format-size
  [[width height]]
  (str width "x" height))

(defn- format-available
  [image-url]
  (if (seq image-url)
    "yes"
    "no"))

(defui render-image [{:keys [value]}]
  (when (seq value)
    (r/as-element
     [preview-pop-up :image (str value "?" (.now js/Date))])))

(def no-rows-overlay
  (uix/as-react
   (fn [{:keys [is-error is-empty]}]
     ($ Stack
        {:alignItems "center"
         :justifyContent "center"
         :height "100%"}
        ($ Typography
           (cond
             is-error "Could not load backup images"
             is-empty "There are no backup images available for this advertiser"
             :else "No results"))))))

(def ^:private columns
  #js [#js {:field "size"
            :headerName "Size"
            :type "string"
            :minWidth 120
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (format-size [(:width row) (:height row)]))}
       #js {:field "available"
            :headerName "Available"
            :type "string"
            :minWidth 100
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (format-available (:imageUrl row)))}
       #js {:field "image"
            :headerName "Image"
            :type "string"
            :minWidth 100
            :flex 1
            :sortable false
            :filterable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:imageUrl row))
            :renderCell (fn [^js params]
                          ($ render-image {:value (.-value params)}))}])

(defn- get-row-id [row]
  (str (:width row) "x" (:height row)))

(defui table []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isPending isError]} (use-query (backup-image.q/backup-images-query {:advertiser-id advertiser-id}))

        page-size 10

        initial-state (uix/use-memo
                       (fn []
                         #js {:pagination #js {:paginationModel #js {:pageSize page-size}}})
                       [page-size])

        on-row-click (uix/use-callback
                      (fn [^js params]
                        (let [backup-image (->clj (.-row params))]
                          (rf/dispatch [:ocp/open {:id :backup-image/edit
                                                   :props {:backup-image backup-image}}])))
                      [])]
    ($ DataGridPremium
       {:columns columns
        :loading isPending

        :rows (to-array (or data []))
        :getRowId get-row-id

        :onRowClick on-row-click

        :pagination true
        :pageSizeOptions #js [page-size]

        :initialState initial-state

        :slots #js {:toolbar dg/grid-toolbar
                    :noRowsOverlay no-rows-overlay}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :noRowsOverlay #js {:is-error isError
                                            :is-empty (empty? data)}}

        :data-testid "backupImageTable"

        :sx #js {"& .MuiDataGrid-row:hover" #js {:cursor "pointer"}
                 :maxHeight "70rem"}})))
